<template>
  <div class="table-responsive" :class="{ 'tbl-inherit': overflowState }">
    <div class="row">
      <div class="col-sm-3">
        <Alert type="danger" :messages="errors" />
      </div>
    </div>
    <div style="width: 100%; overflow-x: visible;">
      <Loader v-show="loading" />
      <table class="table" v-show="!loading">
        <thead>
          <tr>
            <th class="" style="width: 40px!important;">
            </th>
            <th></th>
            <template>
              <th
                v-on:click="sorting('joinedDate')"
                class="text-center arrow-link"
              >
                {{ '登録/更新日' }}
                <i
                  class="fa fa-long-arrow-up"
                  :class="{ active: isJoinedDateAscActive }"
                  aria-hidden="true"
                ></i>
                <i
                  class="fa fa-long-arrow-down"
                  :class="{ active: isJoinedDateDescActive }"
                  aria-hidden="true"
                ></i>
              </th>
              <!-- <th
                class="text-center"
                v-bind:key="menu.title"
                v-else-if="menu.title == '経由' && menu.display == true"
              >
              <span v-show="!isReviewer">経由</span>
                <b-dropdown
                  id="ddown-aria"
                  text="経由"
                  variant="primary"
                  class="m-2 th-dropdown btn-plain-dv"
                  @hidden="search"
                  @shown="overflow"
                  v-show="isReviewer"
                >
                  <div>
                    <div class="form-check">
                      <input
                        type="checkbox"
                        id="own"
                        value="own"
                        class="form-check-input"
                        v-model="companyModel"
                      />
                      <label class="form-check-label">自社HP経由</label>
                    </div>
                    <div class="form-check">
                      <input
                        type="checkbox"
                        id="other"
                        value="other"
                        class="form-check-input"
                        v-model="companyModel"
                      />
                      <label class="form-check-label">他ルート経由</label>
                    </div>
                  </div>
                </b-dropdown>
              </th> -->
              <th class="text-center arrow-link">
                登録者情報
                <!-- <i
              class="fa fa-long-arrow-up"
              :class="{'active': sortKey == 'last_furigana' && asc}"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-long-arrow-down"
              :class="{'active': sortKey == 'last_furigana' && !asc}"
              aria-hidden="true"
                ></i>-->
              </th>
              <th class="text-center arrow-link">
                在籍企業 / 直近職種
                <!-- <i
                  class="fa fa-long-arrow-up"
                  :class="{'active': sortBy == '-birth_date'}"
                  aria-hidden="true"
                ></i>
                <i
                  class="fa fa-long-arrow-down"
                  :class="{'active': sortBy == 'birth_date'}"
                  aria-hidden="true"
                ></i> -->
              </th>
              <th class="text-center">登録者がスカウトを希望している求人</th>
              <!-- <th class="text-center">スカウトする求人</th> -->
            </template>

            <th class="text-center">メモ</th>
            <!-- <th class="text-center">ステータス</th> -->
            <th class="text-center">
              <!-- <span v-show="!isReviewer">登録者ステータス</span> -->
              <b-dropdown
                id="ddown-aria"
                text="ステータス"
                variant="primary"
                class="m-2 th-dropdown"
                @hidden="search"
                @shown="overflow"
              >
                <div>
                  <div
                    class="form-check form-check"
                    v-for="(status, index) in getClientStatus"
                    v-bind:key="index"
                  >
                    <input
                      type="checkbox"
                      :id="index"
                      :value="status"
                      class="form-check-input"
                      v-model="statusModel"
                    />
                    <label class="form-check-label">{{status}}</label>
                  </div>
                </div>
              </b-dropdown>
            </th>
            <!-- <th class="text-center">判定</th> -->
            <!-- <th class="text-center"></th> -->
          </tr>
        </thead>
        <tbody>
          <ApplicantRow
            v-for="(applicant, index) in applicants"
            v-bind:key="applicant.id"
            :applicant="applicant"
            :applicantIndex="index"
            :rowNumber="rowNumber(index)"
            @hidden="overflowState = 0"
            @shown="overflow"
            @changed="checkUncheckJobseeker"
          />
          <tr v-if="showEmptyMessage">
            <td colspan="100%" class="text-center">
              登録者が見つかりませんでした
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-area" v-if="totalPages > 1">
      <paginate :total-page="totalPages" :callback="changePage" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import ApplicantRow from '@/components/dashboard/applicants/ApplicantRow.vue';
import Loader from '@/components/utils/Loader.vue';
import Paginate from '@/components/utils/Paginate.vue';
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import actions from '@/config/actions';
import mutations from '@/config/mutations';
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import Alert from '@/components/utils/Alert.vue';

export default {
  name: 'ApplicantList',
  components: { Paginate, Loader, ApplicantRow, Alert },
  data() {
    return {
      // childJobModel: [],
      // loading: true,
      // pagination: {},
      sortKey: null,
      asc: true,
      // mainJobModel: [],
      overflowState: 0,
      errors: [],
      // isCheckAll: false,
      // jobseekerIds: [],
      perPageRows: ['20件', '50件'],
      selectedLabel: '',
      client_status_list: [
        '未確認',
        '選考対象外',
        '選考対象、未対応',
        '確認中',
        '過去応募済み',
        'コンタクト済み',
        '返信有',
        // 'プッシュ済',

        // '応募有',
        '選考応募有',
        'システム取込み済み',

        '選考NG',
        '中長期的対応',
        'その他',
      ],
      showEmptyMessage: false,
      clientSortBy: null, // Track sort direction for client-side sorting
    };
  },
  async created() {
    try {
      if (this.mainJobModel.length > 0) {
        this.mainJobModelChanged(this.mainJobModel);
        this.search();
      }
      // else{
      //   console.log('called');
      //   this.load(this.buildParams(1));
      // }

      if (this.mainJobModel.length === 0 && this.defaultLoaded) {
        await this.load(this.buildParams(1));
      }
      this.loadMenuConfigurations();
    } catch (error) {
      // Handle any errors that might occur during the creation process
      console.error(error);
    }
  },
  computed: {
    ...mapGetters({
      getChildJobModel: 'getChildJobModel',
      getMainJobModel: 'getMainJobModel',
      getEnglishSkillModel: 'getEnglishSkillModel',
      getStatusModel: 'getStatusModel',
      getClientStatus: 'getClientStatus',
      getColorModel: 'getColorModel',
      getClientColor: 'getClientColor',
      getCompanyModel: 'getCompanyModel',
      getMenus: 'getMenus',
      reviewLists: 'getReviewLists',
      isAdmin: 'currentUserIsAdmin',
      isReviewer: 'isCreateReviewUser',
      getReviewListModel: 'getReviewListModel',
      defaultLoaded: 'getDefaultLoaded',
      isJdSearch: 'getIsJdSearch',
    }),
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      pagination: ({ applicant }) => applicant.pagination,
      reloadApplicants: ({ applicant }) => applicant.reloadApplicants,
      applicantStatusToFilter: ({ applicant }) =>
        applicant.applicantStatusToFilter,
      loading: ({ applicant }) => applicant.loading,
      isCheckAll: ({ applicant }) => applicant.isCheckAll,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      activeCategory: ({ applicant }) => applicant.activeCategory,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      interviewsOnly: ({ applicant }) => applicant.interviewsOnly,
      searchParams: ({ applicant }) => applicant.searchParams,
      sortBy: ({ applicant }) => applicant.sortBy,
      page: ({ applicant }) => applicant.page,
      occupations: ({ applicant }) => applicant.selectors.occupations || [],
      englishSkills: ({ applicant }) => applicant.selectors.englishSkills || [],
    }),
    reviewListModel: {
      get() {
        return this.getReviewListModel;
      },
      set(value) {
        this.setReviewListModel(value);
      },
    },
    mainJobModel: {
      get() {
        return this.getMainJobModel;
      },
      set(value) {
        this.setMainJobModel(value);
      },
    },
    childJobModel: {
      get() {
        return this.getChildJobModel;
      },
      set(value) {
        this.setChildJobModel(value);
      },
    },
    englishSkillModel: {
      get() {
        return this.getEnglishSkillModel;
      },
      set(value) {
        this.setEnglishSkillModel(value);
      },
    },
    statusModel: {
      get() {
        return this.getStatusModel;
      },
      set(value) {
        this.setStatusModel(value);
      },
    },
    colorModel: {
      get() {
        return this.getColorModel;
      },
      set(value) {
        this.setColorModel(value);
      },
    },
    companyModel: {
      get() {
        return this.getCompanyModel;
      },
      set(value) {
        this.setCompanyModel(value);
      },
    },
    totalPages() {
      const { pagination } = this;
      return pagination.total
        ? Math.ceil(pagination.total / pagination.perPage)
        : 0;
    },
    from() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        1
      );
    },
    to() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        this.applicants.length
      );
    },
    // Computed properties for active arrow states
    isJoinedDateAscActive() {
      if (this.isJdSearch) {
        return this.clientSortBy === 'joinedDate';
      }
      return this.sortBy === 'joinedDate';
    },
    isJoinedDateDescActive() {
      if (this.isJdSearch) {
        return this.clientSortBy === '-joinedDate';
      }
      return this.sortBy === '-joinedDate';
    },
  },
  methods: {
    ...mapActions([
      actions.applicant.LOAD_APPLICANTS,
      'loadMenuConfigurations',
      'loadReviewLists',
    ]),
    ...mapMutations([
      mutations.applicant.SET_APPLICANTS,
      mutations.applicant.CHANGE_SORT_COLUMN,
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      'setCurrentPageApplicants',
      'setApplicantCounts',
      'setPage',
      'setChildJobModel',
      'setMainJobModel',
      'setEnglishSkillModel',
      'setStatusModel',
      'setCompanyModel',
      'mutateApplicantsAfterMultipleStatus',
      'updateMainJobModel',
      'setColorModel',
      'setReviewListModel',
      'mutateApplicantsAfterMultipleReviewList',
      'mutateApplicantsAfterMultipleColor',
      'setCheckAll',
      'setReloadApplicants',
      'setLoading',
      'setPagination',
      'setResetCheckAll',
      'setResetApplicantIds'
    ]),
    overflow() {
      this.overflowState = 1;
    },
    checkAll() {
      this.setCheckAll(true);
      // this.isCheckAll = !this.isCheckAll;
      // this.jobseekerIds = [];
      // if (this.isCheckAll) {
      //   // Check all
      //   for (var key in this.applicants) {
      //     this.jobseekerIds.push(this.applicants[key].id);
      //   }
      // }
    },
    // isCheckedJobseeker(id) {
    //   return this.jobseekerIds.includes(id);
    // },
    // isCheckedApplicants(){
    //   return this.jobseekerIds.length?true:false;
    // },
    checkUncheckJobseeker(id) {
      const index = this.jobseekerIds.indexOf(id);
      if (index > -1) {
        this.jobseekerIds.splice(index, 1);
      } else {
        this.jobseekerIds.push(id);
      }
    },
    changeStatus(status) {
      this.errors = [];
      if (this.jobseekerIds.length == 0) {
        this.errors.push('登録者が選択されていません');
      } else {
        // this.loading = true;
        this.setLoading(true);
        ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
          jobseekerIDs: this.jobseekerIds,
          status: status,
        })
          .then(({ data }) => {
            // console.log(data.data)
            this.mutateApplicantsAfterMultipleStatus(data.data);
          })
          .catch(({ response }) => this.parseErrorResponse(response))
          .then(() => {
            // this.loading = false;
            this.setLoading(false);
            this.jobseekerIds = [];
            this.setCheckAll(false);
          });
      }
    },
    // assignToReviewList() {
    //   this.errors = [];
    //   if (this.jobseekerIds.length == 0) {
    //     this.errors.push("登録者が選択されていません");
    //   } else {
    //     this.loading = true;
    //     this.$refs.ddown1.hide();
    //     this.$refs.secondReview.hide();
    //     let list = this.getReviewListModel;
    //     if (!this.getReviewListModel || this.getReviewListModel.length === 0) {
    //       list = null;
    //     }
    //     ApiService.put(Api.endpoints.MULTIPLE_REVIEW_LIST, {
    //       jobseekerIDs: this.jobseekerIds,
    //       list: list,
    //     })
    //       .then(({ data }) => {
    //         this.mutateApplicantsAfterMultipleReviewList(data.data);
    //         this.mutateApplicantsAfterMultipleStatus(data.data);
    //       })
    //       .catch((error) => console.log(error.response))
    //       .then(() => {
    //         this.loading = false;
    //         this.jobseekerIds = [];
    //         this.setCheckAll([]);
    //       });
    //   }
    // },
    // assignToColor() {
    //   this.errors = [];
    //   if (this.jobseekerIds.length == 0) {
    //     this.errors.push("登録者が選択されていません");
    //   } else {
    //     this.loading = true;
    //     this.$refs.colorDropdown.hide();
    //     this.$refs.colorDropdown2.hide();
    //     let color = this.colorModel;
    //     if (!this.colorModel) {
    //       color = null;
    //     }
    //     // console.log(color);
    //     ApiService.put(Api.endpoints.MULTIPLE_COLOR, {
    //       jobseekerIds: this.jobseekerIds,
    //       color: color,
    //     })
    //       .then(({ data }) => {
    //         this.mutateApplicantsAfterMultipleColor(data.data);
    //       })
    //       .catch((error) => console.log(error))
    //       .then(() => {
    //         this.loading = false;
    //         this.jobseekerIds = [];
    //         this.setIsCheckAll(false);
    //         this.setColorModel([]);
    //       });
    //   }
    // },
    async changePerPage(row) {
      const params = { rowPerPage: row == '20件' ? 20 : 50 };

      if (this.searchParams) Object.assign(params, this.searchParams);
      if (this.sortBy) Object.assign(params, { sortBy: this.sortBy });
      await this.load(params);
    },
    sorting(key) {
      let column = '';
      if (this.sortKey !== null) {
        if (this.sortKey === key) {
          if (this.asc) {
            column = key;
            this.asc = false;
          } else {
            column = `-${key}`;
            this.asc = true;
          }
        } else {
          column = `-${key}`;
          this.asc = true;
        }
      } else {
        column = `-${key}`;
        this.asc = true;
      }
      this.sortKey = key;
      
      if(this.isJdSearch) {
        const sortedApplicants = [...this.applicants].sort((a, b) => {
          const aValue = a[key];
          const bValue = b[key];
          
          if (this.asc) {
            return aValue > bValue ? 1 : -1;  
          } else {
            return aValue < bValue ? 1 : -1;
          }
        });
        this[mutations.applicant.SET_APPLICANTS](sortedApplicants);
        // Update client-side sort tracking without triggering server request
        this.clientSortBy = column;
      } else {
        this[mutations.applicant.CHANGE_SORT_COLUMN](column);
      }
      // this.setPage(1);
    },
    async load(params = {}) {
      try {
        this.setLoading(true);
        this.errors = [];
        if (this.isReviewer || this.isAdmin) {
          this.loadReviewLists();
        }

        const { data } = await this[actions.applicant.LOAD_APPLICANTS](params);

        this[mutations.applicant.SET_APPLICANTS](data.data);

        this.setResetCheckAll();

        this.setResetApplicantIds();

        this.setCurrentPageApplicants(data.data);

        this.showEmptyMessage = this.applicants.length === 0;

        this.setPagination(data.meta.pagination || {});
        // this.pagination = data.meta.pagination || {};
        this.showcount();
      } catch (error) {
        console.log(error);
        // this.parseErrorResponse(response);
      } finally {
        // this.loading = false;
        this.setLoading(false);
        this.setReloadApplicants(false);
      }
    },
    buildParams(page = null) {
      const params = {};
      if (page) params.page = page;
      // if (this.activeCategory) params.category = this.activeCategory;
      if (this.pagination.perPage == 50) params.rowPerPage = 50;
      if (this.favoritesOnly) params.favorites = 1;
      if (this.interviewsOnly) params.interviews = 1;
      // console.log(this.searchParams);
      if(this.searchParams && Object.keys(this.searchParams).length > 0){
        Object.assign(params, this.searchParams);
      }
      // console.log(params);

      // if (this.searchParams && Object.keys(this.searchParams).length > 0) {
      //   Object.assign(params, this.searchParams);
      //   params.initialStatusModel = [];
      // } else {
      //   params.initialStatusModel =
      //     this.applicantStatusToFilter === '未確認' ? ['未確認'] : [];
      // }

      // // 🧠 Apply default "未確認" only if applicable and user hasn't selected manually
      // if (isStatusModelUnchanged && this.applicantStatusToFilter === '未確認') {
      //   this.statusModel = ['未確認'];
      // } else if (
      //   this.applicantStatusToFilter === '全て表示' &&
      //   isStatusModelUnchanged
      // ) {
      //   this.statusModel = [];
      // }
      if (this.sortBy) params.sort = this.sortBy;
      params.isNewPanel = true;
      // if(!this.isReviewer) this.setStatusModel(['社内確認待bち']);
      // console.log(params);
      return params;
    },
    changePage(page) {
      this.setPage(page);
      // this.load(this.buildParams(page));
    },
    rowNumber(index) {
      return (
        index +
        1 +
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage
      );
    },
    showcount() {
      this.setApplicantCounts({
        total: this.pagination.total,
        from: this.from,
        to: this.to,
        perPage: this.pagination.perPage,
      });
    },
    isChecked(id) {
      if (this.mainJobModel.indexOf(id) !== -1) return true;
      return false;
    },
    search() {
      const params = {};
      console.log(this.searchParams);
      Object.assign(params, this.searchParams);
      params.childOccupations = this.childJobModel;
      params.englishSkills = this.englishSkillModel;
      params.status = this.statusModel;
      params.regcompany = this.companyModel;
      params.client_color = this.colorModel;
      if (params.childOccupations.length === 0) delete params.childOccupations;
      if (params.englishSkills.length === 0) delete params.englishSkills;
      this[mutations.applicant.CHANGE_SEARCH_PARAMS](params);
      this.overflowState = 0;
    },
  },
  watch: {
    reloadApplicants: function() {
      // console.log(this.page);
      if (this.page === 1) {
        this.load(this.buildParams(1));
      } else {
        this.load(this.buildParams(this.page));
      }
    },
    applicantStatusToFilter: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    activeCategory(categories) {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    favoritesOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    interviewsOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    searchParams: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    page: function(currentPage) {
      this.load(this.buildParams(currentPage));
    },
    // eslint-disable-next-line
    sortBy: function(value) {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // mainJobModel(mainJobs) {
    //   this.updateMainJobModel({mainJobs});
    // },
  },
};
</script>
<style scoped>
thead {
  border-bottom: 1px solid #787878;
}
.client-listing-detail table th a {
  color: #036d6c;
  font-size: 12px;
  text-decoration: none !important;
}

.color-th >>> .btn {
  min-width: 10px !important;
}

.color-th >>> .dropdown-menu {
  min-width: 150px;
}
.arrow-link i {
  color: #d0c2c2;
}
.arrow-link i.active {
  color: #036d6c;
}
.reviewer {
  background: none !important;
  color: #036d6c;
  border: none !important;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 0 5px 0;
}
.reviewer:hover {
  background: none !important;
  color: #036d6c !important;
}
.th-dropdown-text {
  display: inline-block;
  min-width: 180px; /* or your desired width */
}

>>> .th-dropdown .btn {
  color: #3c3c3c !important;
  font-size: 14px !important;
}

tbody tr {
  cursor: pointer;
  border: 2px;
}
th.arrow-link:hover {
  cursor: pointer;
  padding: 5px 7px !important;
}

.table-responsive {
  overflow-x: visible;
}
</style>
